var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isINOsale)?_c('Presale'):(_vm.isSimpleSale)?_c('Simplesale'):_c('Tokensale'),_c('div',{staticClass:"main-wrap"},[_c('div',{staticClass:"text-right launchpad__link"},[_c('router-link',{attrs:{"to":{ name: 'agreement' }}},[_vm._v("User Agreement")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }